import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NotificationInitialState, SelectOptionType } from '../utils/Types';
import { getAllNotifications, getNotificationTypes } from '../services';
import { API_STATUS } from '../utils/Constant';
import { isAPISuccess } from '../utils/Util';
const initialState: NotificationInitialState = {
  status: '',
  types: [],
};

export const getNotifications = createAsyncThunk(
  'notifications/getNotifications',
  async (data: any) => {
    const res = await getAllNotifications(data);
    return res.data;
  }
);
export const getTypes = createAsyncThunk('notifications/getTypes', async () => {
  const res = await getNotificationTypes();
  return res.data;
});

export const notificationsSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getTypes.fulfilled, (state, action) => {
      if (isAPISuccess(action.payload)) {
        const result = action.payload.result;
        const selectOptions: SelectOptionType[] = [];
        result.forEach(
          (element: { moduleId: number | string; moduleName: string }) => {
            if (
              !element.moduleName.includes('Remuneration') ||
              element.moduleName !== 'Remunerations'
            ) {
              selectOptions.push({
                value: element.moduleId,
                label: element.moduleName,
              });
            }
          }
        );
        state.types = selectOptions;
        state.status = API_STATUS.SUCCEEDED;
      } else {
        state.types = [];
        state.status = API_STATUS.FAILED;
      }
    });
  },
});

export const notificationSelector = (state: {
  notification: NotificationInitialState;
}) => state.notification;

export default notificationsSlice.reducer;
